import React, { useEffect, useMemo, useState } from "react"
import {
  computeKyotoOpeningDisplay,
  getKyotoSimulatedNow,
} from "../utils/kyotoOpeningHours"

/** Mobil unter dem Header (alle Seiten) */
const HomeOpeningHoursMobile = () => {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60_000)
    return () => clearInterval(id)
  }, [])

  const { isOpen, title, subtitle } = useMemo(
    () => computeKyotoOpeningDisplay(getKyotoSimulatedNow()),
    [tick]
  )

  return (
    <div
      className="text-center py-2.5 px-4 bg-white border-b border-black/10"
      aria-live="polite"
    >
      <p className="text-[10px] uppercase tracking-wide text-black/55 mb-1.5">
        Öffnungszeiten
      </p>
      <div className="flex items-center justify-center gap-2">
        <span
          className={`w-2 h-2 rounded-full shrink-0 ${
            isOpen
              ? "bg-green-600 animate-opening-status-pulse"
              : "bg-neutral-400"
          }`}
          aria-hidden
        />
        <span className="text-sm font-medium text-black">{title}</span>
      </div>
      {subtitle ? (
        <p className="text-xs text-black/80 mt-1.5 leading-snug px-1">{subtitle}</p>
      ) : null}
    </div>
  )
}

export default HomeOpeningHoursMobile
